import { Alert, Stack } from '@mui/material';

import { Text } from 'common';

import { BlockCodeMirrorField, LanguageMode } from '../../ConfigFields/CodeMirror/CodeMirror';
import { BlockSwitchField } from '../../ConfigFields/Switch';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

export function MockInputs() {
  const inputModeField = useSelectedNodeField<'Mocked' | 'CallerDefined' | undefined>(
    'config.inputMode'
  );

  return (
    <Stack gap={2}>
      <BlockSwitchField<'Mocked', 'CallerDefined'>
        fieldName="config.inputMode"
        label="Mock inputs for test run"
        toggleStates={{ activeState: 'Mocked', inactiveState: 'CallerDefined' }}
      />
      {inputModeField.value === 'Mocked' && (
        <>
          <Alert severity="info">
            <Text variant="body2" bold>
              Applies to test runs only
            </Text>
            <Text variant="subtitle2">
              Production flow runs always use the caller&apos;s inputs.
            </Text>
          </Alert>
          <BlockCodeMirrorField
            languageMode={LanguageMode.Json}
            label="Mock inputs JSON"
            fieldName="config.mockInputs"
            helperText="A JSON object mapping input name → value. Injected as {{inputs.<key>}} on test runs."
          />
        </>
      )}
    </Stack>
  );
}
